<template >
  <b-modal
      id="modal_form"
      ref="modal_form"
      :title="modal_titulo"
      :ok-title="modal_botao"
      close-title="Fechar"
      cancel-title="Cancelar"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      :ok-disabled="form.errors.any()"
      v-model="showModal"
      :destroy-on-close="true"
  >
    <form>
      <b-row class="pb-1 pr-1">
        <b-col>
          <b-input
              id="cdBarra"
              maxlength="44"
              autofocus
              type="text"
              v-on:keyup.enter="onScan()"
              v-model="cd_barra"
              @contextmenu="handleWritingBarcodePermission($event)"
              @dragover="handleWritingBarcodePermission($event)"
              @paste="handleWritingBarcodePermission($event)"
              @drop="handleWritingBarcodePermission($event)"
              ref="cdBarra"
          ></b-input>
          <span>Qtde. caracteres código de barra: {{ qtdCaracteres() }}</span>
        </b-col>
        <b-col class="p-0">
          <b-btn :disabled="loading" @click="onScan()" variant="secondary"
          >Escanear código</b-btn
          >
        </b-col>
        <b-col md="4" style="display: flex; align-items: center">
          <span>Qtde. NFs bipados / Quantidade de NFs : </span>
          <h4 class="ml-1">
            {{ this.qtd_nfs_bipados_total }}/{{ this.qtd_nfs_total }}
          </h4>
        </b-col>
        <b-col class="p-0">
          <b-btn
              :disabled="loading"
              @click="onCancelBip()"
              style="
              background-color: #dc3545 !important;
              border: #dc3545 1px solid;
            "
          >Cancelar Bipagem</b-btn
          >
        </b-col>
      </b-row>
      <b-row class="pb-1 pr-1" v-for="item in redespachos" :key="item.cnpj">
        <b-col md="4" style="display: flex; align-items: center">
          <span>{{ item.nome }} - {{ ajustaMascara(item.cnpj) }}: </span>
          <h4 class="ml-1">{{ item.qtde_total_bip }}/{{ item.qtde_total }}</h4>
        </b-col>
      </b-row>
    </form>

    <div class="horizontal-scroll">
      <div class="loadingDataPosition">
        <div class="loadingData" v-if="loading"></div>
        <vuetable
            ref="vuetable"
            :api-mode="false"
            :data="documentos"
            :fields="fields"
            :css="css"
            :append-params="moreParams"
            :row-class="onRowClass"
            track-by="cargabipdoc_id"
            pagination-path=""
            @vuetable:load-error="onError"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loaded="onLoaded"
        >
          <template slot="status" slot-scope="props">
            <span class="badge badge-warning" v-if="props.rowData.status.valor == 1"
            >Não checado</span
            >
            <span class="badge badge-success" v-if="props.rowData.status.valor == 2"
            >Checado</span
            >
          </template>
          <template slot="redespacho" slot-scope="props">
            <span v-if="props.rowData.red_nome"
            >{{ props.rowData.red_nome }} -
              {{ ajustaMascara(props.rowData.red_cnpj) }}
            </span>
          </template>
          <template slot="emissor" slot-scope="props">
            <span v-if="props.rowData.emi_nome"
            >{{ props.rowData.emi_nome }} -
              {{ ajustaMascara(props.rowData.emi_cnpj) }}
            </span>
          </template>
          <template slot="regiao_despesa" slot-scope="props">
            <span v-if="props.rowData.regiao_despesa != null"
            >{{ props.rowData.regiao_despesa }}
            </span>
          </template>
        </vuetable>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="handleFechar()" variant="secondary"> Fechar </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import WritingBarcodePermission from '../mixins/WritingBarcodePermission';

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  mixins: [WritingBarcodePermission],
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      tp_fechar: false,
      permission: true,
      paste: false,
      modal_botao: "",
      modal_acao: "",
      loading: false,
      documentos: [],
      song: new Audio(),
      sucesso: require("../../public/audio/sucesso.mp3"),
      erro: require("../../public/audio/erro.mp3"),
      redespachos: [],
      permite_digitar: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      errors_array: [],
      notas_fiscais: [],
      qtd_nfs_total: 0,
      qtd_nfs_bipados_total: 0,
      carga_id: "",
      cd_barra: "",
      num_carga: "",
      form: new Form({
        carga_id: "",
        cd_barra: "",
      }),
      helpForm: new Form({ search: "", carga_id: "" }),
      fields: [
        {
          name: "num_fiscal",
          title: "N° Fiscal",
        },
        {
          name: "chave",
          title: "Chave",
        },
        {
          name: "__slot:redespacho",
          title: "Redespacho",
        },
        {
          name: "__slot:emissor",
          title: "Emissor",
        },
        {
          name: "__slot:regiao_despesa",
          title: "Região",
        },
        {
          name: "usuario_bip",
          title: "Usuário Bip",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  created() {
    this.setPermissionToCheck('expedicao.digitaretiqueta');
  },
  methods: {
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onCreate(carga_id) {

      this.errors_array = "";
      this.errors_array = [];
      this.modal_titulo = "Checagem Carga";
      this.modal_botao = "Checagem Carga";
      this.modal_acao = "i";
      this.form.reset();
      this.documentos = [];
      this.redespachos = [];
      this.loading = true;

      this.isDisabled = true;
      this.tp_fechar = false;
      this.qtd_nfs_total = 0;
      this.qtd_nfs_bipados_total = 0;
      this.form.carga_id = carga_id;

      this.form
          .post("/api/expedicao/buscanfscarga")
          .then((response) => {
            new ReturnApi(response, this);
            this.redespachos = response.redespachos;
            response.data.forEach((item, i) => {
                this.documentos.push({
                  carbipdoc_id: item.carbipdoc_id,
                  docfis_id: item.docfis_id,
                  num_fiscal: item.num_fiscal,
                  chave: item.chave,
                  num_lote: item.num_lote,
                  emi_cnpj: item.emi_cnpj,
                  emi_nome: item.emi_nome,
                  red_nome: item.red_nome,
                  red_cnpj: item.red_cnpj,
                  bipado: item.bipado,
                  status: item.status,
                  regiao_despesa: item.regiao_despesa,
                  usuario_bip: item.usuario_bip
                });
                if(item.status.valor == 2) {
                  this.qtd_nfs_bipados_total++;
                }
            });

            this.qtd_nfs_total = this.documentos.length;

            this.form.documentos = this.documentos;
            this.qtde_nfs = this.documentos.length;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });

      this.$refs.modal_form.show();
    },
    onScan() {
      this.errors_array = [];
      this.loading = true;
      this.isDisabled = true;
      this.form.cd_barra = this.cd_barra;

      this.form
          .post("/api/expedicao/bipnfschecagem")
          .then((response) => {
            new ReturnApi(response, this);
            this.tocaMusica(this.sucesso);
            this.index = this.documentos.findIndex((e) => e.carbipdoc_id === response.data.carbipdoc_id)

            this.$set(this.documentos, this.index, response.data);

            if(this.documentos[this.index].status.valor === 2) {
              this.qtd_nfs_bipados_total++;
            }
            if (
                response.redespacho.cnpj != null &&
                this.redespachos[response.redespacho.cnpj] !== undefined
            ) {
              this.redespachos[response.redespacho.cnpj].qtde_total_bip++;
            }

            this.cd_barra = "";
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.tocaMusica(this.erro);
            this.errors_array = "";
            this.errors_array = [];
            this.cd_barra = "";
            for (const property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
            this.$refs.cdBarra.$el.focus();
          });
    },
    onCancelBip() {
      const vm = this;
      const carga_id = this.form.carga_id;
      const onConfirmUnitWrapper = () => {
        confirmCancelFn(vm, carga_id);
      };

      let confirmCancelFn = function (vm, carga_id) {
        vm.form
            .post("/api/expedicao/cancelbipnfs")
            .then((response) => {
              new ReturnApi(response, vm);
            })
            .catch((errors) => {
              new ReturnApi(errors, vm);
            });
      };

      let obj = {
        title: "Atenção!",
        message: "Deseja prosseguir com o cancelamento da bipagem?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    handleFechar() {
      this.showModal = false;
    },
    tocaMusica(musica) {
      this.song.pause();
      this.song.currentTime = 0;
      this.song.src = musica;
      this.song.play();
    },
    onRowClass(data) {
      if (data.status.valor == 1) {
        return "table-warning";
      } else {
        return "table-success";
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
          ? ""
          : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
              /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
              "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    qtdCaracteres() {
      return this.cd_barra.length;
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
  watch: {
    'cd_barra'(newValue, oldValue){
      this.handleWritingBarcodePermission(newValue, oldValue)
    }
  }
};
</script>
<style>
.horizontal-scroll {
  overflow-y: auto;
}
</style>